@file:OptIn(InternalResourceApi::class)

package com.flowyride.feature.planner.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.flowyride.feature.planner.resources/"

@delegate:ResourceContentHash(165_000_120)
internal val Res.string.add_stop: StringResource by lazy {
      StringResource("string:add_stop", "add_stop", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 137, 40),
      ))
    }

@delegate:ResourceContentHash(-2_046_154_531)
internal val Res.string.arrival_label: StringResource by lazy {
      StringResource("string:arrival_label", "arrival_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 178, 33),
      ))
    }

@delegate:ResourceContentHash(-188_793_413)
internal val Res.string.avoid_motorways: StringResource by lazy {
      StringResource("string:avoid_motorways", "avoid_motorways", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 212, 55),
      ))
    }

@delegate:ResourceContentHash(-1_721_916_154)
internal val Res.string.back: StringResource by lazy {
      StringResource("string:back", "back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 268, 20),
      ))
    }

@delegate:ResourceContentHash(-1_065_163_855)
internal val Res.string.cancel: StringResource by lazy {
      StringResource("string:cancel", "cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 289, 26),
      ))
    }

@delegate:ResourceContentHash(-1_494_255_007)
internal val Res.string.character_flowing: StringResource by lazy {
      StringResource("string:character_flowing", "character_flowing", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 316, 37),
      ))
    }

@delegate:ResourceContentHash(-964_832_926)
internal val Res.string.character_pleasant: StringResource by lazy {
      StringResource("string:character_pleasant", "character_pleasant", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 354, 34),
      ))
    }

@delegate:ResourceContentHash(-1_732_306_128)
internal val Res.string.character_twisty: StringResource by lazy {
      StringResource("string:character_twisty", "character_twisty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 389, 36),
      ))
    }

@delegate:ResourceContentHash(850_646_653)
internal val Res.string.character_very_twisty: StringResource by lazy {
      StringResource("string:character_very_twisty", "character_very_twisty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 426, 49),
      ))
    }

@delegate:ResourceContentHash(-1_235_881_256)
internal val Res.string.clear_field: StringResource by lazy {
      StringResource("string:clear_field", "clear_field", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 476, 31),
      ))
    }

@delegate:ResourceContentHash(-1_235_881_256)
internal val Res.string.clear_stops: StringResource by lazy {
      StringResource("string:clear_stops", "clear_stops", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 666, 31),
      ))
    }

@delegate:ResourceContentHash(714_111_872)
internal val Res.string.clear_stops_message: StringResource by lazy {
      StringResource("string:clear_stops_message", "clear_stops_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 508, 99),
      ))
    }

@delegate:ResourceContentHash(-572_891_560)
internal val Res.string.clear_stops_title: StringResource by lazy {
      StringResource("string:clear_stops_title", "clear_stops_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 608, 57),
      ))
    }

@delegate:ResourceContentHash(1_707_039_062)
internal val Res.string.close: StringResource by lazy {
      StringResource("string:close", "close", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 698, 21),
      ))
    }

@delegate:ResourceContentHash(508_629_890)
internal val Res.string.collapse: StringResource by lazy {
      StringResource("string:collapse", "collapse", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 720, 28),
      ))
    }

@delegate:ResourceContentHash(-2_065_958_515)
internal val Res.string.curvature_value: StringResource by lazy {
      StringResource("string:curvature_value", "curvature_value", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 749, 63),
      ))
    }

@delegate:ResourceContentHash(2_008_912_630)
internal val Res.string.decrease: StringResource by lazy {
      StringResource("string:decrease", "decrease", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 813, 24),
      ))
    }

@delegate:ResourceContentHash(-695_941_392)
internal val Res.string.departure_label: StringResource by lazy {
      StringResource("string:departure_label", "departure_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 838, 35),
      ))
    }

@delegate:ResourceContentHash(2_522_655)
internal val Res.string.direction_e: StringResource by lazy {
      StringResource("string:direction_e", "direction_e", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 874, 23),
      ))
    }

@delegate:ResourceContentHash(2_603_379)
internal val Res.string.direction_n: StringResource by lazy {
      StringResource("string:direction_n", "direction_n", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 948, 23),
      ))
    }

@delegate:ResourceContentHash(2_607_967)
internal val Res.string.direction_ne: StringResource by lazy {
      StringResource("string:direction_ne", "direction_ne", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 898, 24),
      ))
    }

@delegate:ResourceContentHash(2_607_068)
internal val Res.string.direction_nw: StringResource by lazy {
      StringResource("string:direction_nw", "direction_nw", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 923, 24),
      ))
    }

@delegate:ResourceContentHash(2_648_546)
internal val Res.string.direction_s: StringResource by lazy {
      StringResource("string:direction_s", "direction_s", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1022, 23),
      ))
    }

@delegate:ResourceContentHash(2_581_059)
internal val Res.string.direction_se: StringResource by lazy {
      StringResource("string:direction_se", "direction_se", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 972, 24),
      ))
    }

@delegate:ResourceContentHash(2_580_160)
internal val Res.string.direction_sw: StringResource by lazy {
      StringResource("string:direction_sw", "direction_sw", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 997, 24),
      ))
    }

@delegate:ResourceContentHash(2_618_755)
internal val Res.string.direction_w: StringResource by lazy {
      StringResource("string:direction_w", "direction_w", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1046, 23),
      ))
    }

@delegate:ResourceContentHash(1_171_014_953)
internal val Res.string.drag_stop: StringResource by lazy {
      StringResource("string:drag_stop", "drag_stop", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1070, 49),
      ))
    }

@delegate:ResourceContentHash(1_949_548_155)
internal val Res.string.engine_label: StringResource by lazy {
      StringResource("string:engine_label", "engine_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1120, 28),
      ))
    }

@delegate:ResourceContentHash(1_863_485_194)
internal val Res.string.engine_not_configured: StringResource by lazy {
      StringResource("string:engine_not_configured", "engine_not_configured", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1149, 85),
      ))
    }

@delegate:ResourceContentHash(-1_480_355_031)
internal val Res.string.error_engine: StringResource by lazy {
      StringResource("string:error_engine", "error_engine", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1235, 64),
      ))
    }

@delegate:ResourceContentHash(2_125_191_592)
internal val Res.string.error_export: StringResource by lazy {
      StringResource("string:error_export", "error_export", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1300, 44),
      ))
    }

@delegate:ResourceContentHash(-2_071_704_040)
internal val Res.string.error_favorite: StringResource by lazy {
      StringResource("string:error_favorite", "error_favorite", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1410, 70),
      ))
    }

@delegate:ResourceContentHash(1_951_621_423)
internal val Res.string.error_favorite_not_found: StringResource by lazy {
      StringResource("string:error_favorite_not_found", "error_favorite_not_found", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1345, 64),
      ))
    }

@delegate:ResourceContentHash(302_196_602)
internal val Res.string.error_gpx_invalid: StringResource by lazy {
      StringResource("string:error_gpx_invalid", "error_gpx_invalid", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1481, 121),
      ))
    }

@delegate:ResourceContentHash(-1_146_779_066)
internal val Res.string.error_gpx_read: StringResource by lazy {
      StringResource("string:error_gpx_read", "error_gpx_read", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1603, 62),
      ))
    }

@delegate:ResourceContentHash(-467_645_249)
internal val Res.string.error_invalid_response: StringResource by lazy {
      StringResource("string:error_invalid_response", "error_invalid_response", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1666, 70),
      ))
    }

@delegate:ResourceContentHash(-29_602_862)
internal val Res.string.error_location: StringResource by lazy {
      StringResource("string:error_location", "error_location", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1737, 102),
      ))
    }

@delegate:ResourceContentHash(1_465_724_296)
internal val Res.string.error_loop_no_departure: StringResource by lazy {
      StringResource("string:error_loop_no_departure", "error_loop_no_departure", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1840, 79),
      ))
    }

@delegate:ResourceContentHash(123_821_476)
internal val Res.string.error_network: StringResource by lazy {
      StringResource("string:error_network", "error_network", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1920, 81),
      ))
    }

@delegate:ResourceContentHash(-875_269_690)
internal val Res.string.error_no_loop: StringResource by lazy {
      StringResource("string:error_no_loop", "error_no_loop", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2002, 125),
      ))
    }

@delegate:ResourceContentHash(-768_057_482)
internal val Res.string.error_no_route: StringResource by lazy {
      StringResource("string:error_no_route", "error_no_route", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2128, 86),
      ))
    }

@delegate:ResourceContentHash(-369_093_462)
internal val Res.string.error_rate_limited: StringResource by lazy {
      StringResource("string:error_rate_limited", "error_rate_limited", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2215, 86),
      ))
    }

@delegate:ResourceContentHash(-227_744_289)
internal val Res.string.error_search: StringResource by lazy {
      StringResource("string:error_search", "error_search", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2302, 64),
      ))
    }

@delegate:ResourceContentHash(-1_260_075_458)
internal val Res.string.error_speed_cameras: StringResource by lazy {
      StringResource("string:error_speed_cameras", "error_speed_cameras", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2367, 75),
      ))
    }

@delegate:ResourceContentHash(-387_190_014)
internal val Res.string.error_too_many_stops: StringResource by lazy {
      StringResource("string:error_too_many_stops", "error_too_many_stops", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2443, 68),
      ))
    }

@delegate:ResourceContentHash(726_929_034)
internal val Res.string.expand: StringResource by lazy {
      StringResource("string:expand", "expand", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2512, 26),
      ))
    }

@delegate:ResourceContentHash(2_492_086)
internal val Res.string.export_gpx_short: StringResource by lazy {
      StringResource("string:export_gpx_short", "export_gpx_short", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2539, 28),
      ))
    }

@delegate:ResourceContentHash(-981_801_054)
internal val Res.string.favorite_delete: StringResource by lazy {
      StringResource("string:favorite_delete", "favorite_delete", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2681, 35),
      ))
    }

@delegate:ResourceContentHash(792_027_800)
internal val Res.string.favorite_delete_confirm: StringResource by lazy {
      StringResource("string:favorite_delete_confirm", "favorite_delete_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2568, 63),
      ))
    }

@delegate:ResourceContentHash(-1_312_093_082)
internal val Res.string.favorite_deleted: StringResource by lazy {
      StringResource("string:favorite_deleted", "favorite_deleted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2632, 48),
      ))
    }

@delegate:ResourceContentHash(-1_788_702_894)
internal val Res.string.favorite_imported_badge: StringResource by lazy {
      StringResource("string:favorite_imported_badge", "favorite_imported_badge", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2717, 43),
      ))
    }

@delegate:ResourceContentHash(2_609_076)
internal val Res.string.favorite_name_label: StringResource by lazy {
      StringResource("string:favorite_name_label", "favorite_name_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2761, 31),
      ))
    }

@delegate:ResourceContentHash(-1_372_356_838)
internal val Res.string.favorite_options: StringResource by lazy {
      StringResource("string:favorite_options", "favorite_options", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2793, 48),
      ))
    }

@delegate:ResourceContentHash(983_816_796)
internal val Res.string.favorite_rename: StringResource by lazy {
      StringResource("string:favorite_rename", "favorite_rename", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2842, 35),
      ))
    }

@delegate:ResourceContentHash(715_359_707)
internal val Res.string.favorite_save: StringResource by lazy {
      StringResource("string:favorite_save", "favorite_save", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3030, 37),
      ))
    }

@delegate:ResourceContentHash(-2_041_063_260)
internal val Res.string.favorite_save_title: StringResource by lazy {
      StringResource("string:favorite_save_title", "favorite_save_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2878, 55),
      ))
    }

@delegate:ResourceContentHash(-1_942_590_470)
internal val Res.string.favorite_saved: StringResource by lazy {
      StringResource("string:favorite_saved", "favorite_saved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2979, 50),
      ))
    }

@delegate:ResourceContentHash(716_192_026)
internal val Res.string.favorite_saved_label: StringResource by lazy {
      StringResource("string:favorite_saved_label", "favorite_saved_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2934, 44),
      ))
    }

@delegate:ResourceContentHash(1_526_716_795)
internal val Res.string.favorites_button: StringResource by lazy {
      StringResource("string:favorites_button", "favorites_button", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3068, 40),
      ))
    }

@delegate:ResourceContentHash(967_041_355)
internal val Res.string.favorites_empty: StringResource by lazy {
      StringResource("string:favorites_empty", "favorites_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3109, 127),
      ))
    }

@delegate:ResourceContentHash(797_457_552)
internal val Res.string.favorites_failed: StringResource by lazy {
      StringResource("string:favorites_failed", "favorites_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3237, 72),
      ))
    }

@delegate:ResourceContentHash(-2_134_280_871)
internal val Res.string.favorites_import_gpx: StringResource by lazy {
      StringResource("string:favorites_import_gpx", "favorites_import_gpx", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3310, 48),
      ))
    }

@delegate:ResourceContentHash(1_526_716_795)
internal val Res.string.favorites_title: StringResource by lazy {
      StringResource("string:favorites_title", "favorites_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3359, 39),
      ))
    }

@delegate:ResourceContentHash(1_896_788_230)
internal val Res.string.gpx_choose_track_message: StringResource by lazy {
      StringResource("string:gpx_choose_track_message", "gpx_choose_track_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3399, 84),
      ))
    }

@delegate:ResourceContentHash(2_037_779_892)
internal val Res.string.gpx_choose_track_title: StringResource by lazy {
      StringResource("string:gpx_choose_track_title", "gpx_choose_track_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3484, 50),
      ))
    }

@delegate:ResourceContentHash(723_059_031)
internal val Res.string.gpx_points_confirm: StringResource by lazy {
      StringResource("string:gpx_points_confirm", "gpx_points_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3535, 38),
      ))
    }

@delegate:ResourceContentHash(183_201_066)
internal val Res.string.gpx_points_message: StringResource by lazy {
      StringResource("string:gpx_points_message", "gpx_points_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3574, 242),
      ))
    }

@delegate:ResourceContentHash(-2_123_172_032)
internal val Res.string.gpx_points_title: StringResource by lazy {
      StringResource("string:gpx_points_title", "gpx_points_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3817, 64),
      ))
    }

@delegate:ResourceContentHash(-533_536_043)
internal val Res.string.gpx_saved_to_favorites: StringResource by lazy {
      StringResource("string:gpx_saved_to_favorites", "gpx_saved_to_favorites", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3882, 86),
      ))
    }

@delegate:ResourceContentHash(655_078_234)
internal val Res.string.imported_close: StringResource by lazy {
      StringResource("string:imported_close", "imported_close", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3969, 46),
      ))
    }

@delegate:ResourceContentHash(-112_470_543)
internal val Res.string.imported_hint: StringResource by lazy {
      StringResource("string:imported_hint", "imported_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4016, 97),
      ))
    }

@delegate:ResourceContentHash(779_951_437)
internal val Res.string.imported_title: StringResource by lazy {
      StringResource("string:imported_title", "imported_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4114, 42),
      ))
    }

@delegate:ResourceContentHash(-112_908_705)
internal val Res.string.increase: StringResource by lazy {
      StringResource("string:increase", "increase", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4157, 24),
      ))
    }

@delegate:ResourceContentHash(-1_402_026_800)
internal val Res.string.label_my_position: StringResource by lazy {
      StringResource("string:label_my_position", "label_my_position", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4182, 53),
      ))
    }

@delegate:ResourceContentHash(2_588_273)
internal val Res.string.level_high: StringResource by lazy {
      StringResource("string:level_high", "level_high", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4236, 22),
      ))
    }

@delegate:ResourceContentHash(2_603_181)
internal val Res.string.level_low: StringResource by lazy {
      StringResource("string:level_low", "level_low", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4259, 21),
      ))
    }

@delegate:ResourceContentHash(67_446_555)
internal val Res.string.level_normal: StringResource by lazy {
      StringResource("string:level_normal", "level_normal", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4281, 28),
      ))
    }

@delegate:ResourceContentHash(850_188_320)
internal val Res.string.locate_me: StringResource by lazy {
      StringResource("string:locate_me", "locate_me", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4310, 49),
      ))
    }

@delegate:ResourceContentHash(-2_099_553_444)
internal val Res.string.locating_rider: StringResource by lazy {
      StringResource("string:locating_rider", "locating_rider", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4360, 58),
      ))
    }

@delegate:ResourceContentHash(2_147_406_754)
internal val Res.string.loop_direction_any: StringResource by lazy {
      StringResource("string:loop_direction_any", "loop_direction_any", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4419, 34),
      ))
    }

@delegate:ResourceContentHash(-318_999_405)
internal val Res.string.loop_direction_label: StringResource by lazy {
      StringResource("string:loop_direction_label", "loop_direction_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4454, 40),
      ))
    }

@delegate:ResourceContentHash(814_590_503)
internal val Res.string.loop_from: StringResource by lazy {
      StringResource("string:loop_from", "loop_from", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4495, 41),
      ))
    }

@delegate:ResourceContentHash(-995_350_323)
internal val Res.string.loop_generate: StringResource by lazy {
      StringResource("string:loop_generate", "loop_generate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4537, 49),
      ))
    }

@delegate:ResourceContentHash(658_146_801)
internal val Res.string.loop_generating: StringResource by lazy {
      StringResource("string:loop_generating", "loop_generating", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4587, 59),
      ))
    }

@delegate:ResourceContentHash(2_122_375_322)
internal val Res.string.loop_hint: StringResource by lazy {
      StringResource("string:loop_hint", "loop_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4647, 109),
      ))
    }

@delegate:ResourceContentHash(102_024_470)
internal val Res.string.loop_reroll: StringResource by lazy {
      StringResource("string:loop_reroll", "loop_reroll", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4757, 35),
      ))
    }

@delegate:ResourceContentHash(936_007_254)
internal val Res.string.loop_target_distance: StringResource by lazy {
      StringResource("string:loop_target_distance", "loop_target_distance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4793, 40),
      ))
    }

@delegate:ResourceContentHash(-1_065_231_496)
internal val Res.string.loop_target_duration: StringResource by lazy {
      StringResource("string:loop_target_duration", "loop_target_duration", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4834, 36),
      ))
    }

@delegate:ResourceContentHash(-1_285_704_193)
internal val Res.string.map_pick_arrival: StringResource by lazy {
      StringResource("string:map_pick_arrival", "map_pick_arrival", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4871, 40),
      ))
    }

@delegate:ResourceContentHash(1_563_716_907)
internal val Res.string.map_pick_departure: StringResource by lazy {
      StringResource("string:map_pick_departure", "map_pick_departure", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4912, 42),
      ))
    }

@delegate:ResourceContentHash(1_072_422_306)
internal val Res.string.map_pick_save_place: StringResource by lazy {
      StringResource("string:map_pick_save_place", "map_pick_save_place", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4955, 55),
      ))
    }

@delegate:ResourceContentHash(-654_236_540)
internal val Res.string.map_pick_stop: StringResource by lazy {
      StringResource("string:map_pick_stop", "map_pick_stop", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5011, 53),
      ))
    }

@delegate:ResourceContentHash(-932_812_799)
internal val Res.string.mode_loop: StringResource by lazy {
      StringResource("string:mode_loop", "mode_loop", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5065, 25),
      ))
    }

@delegate:ResourceContentHash(-2_026_298_495)
internal val Res.string.move_down: StringResource by lazy {
      StringResource("string:move_down", "move_down", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5091, 29),
      ))
    }

@delegate:ResourceContentHash(2_013_552_677)
internal val Res.string.move_up: StringResource by lazy {
      StringResource("string:move_up", "move_up", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5121, 23),
      ))
    }

@delegate:ResourceContentHash(-725_625_480)
internal val Res.string.my_position: StringResource by lazy {
      StringResource("string:my_position", "my_position", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5145, 35),
      ))
    }

@delegate:ResourceContentHash(1_103_004_144)
internal val Res.string.navigation_simulate: StringResource by lazy {
      StringResource("string:navigation_simulate", "navigation_simulate", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5181, 39),
      ))
    }

@delegate:ResourceContentHash(-1_123_581_391)
internal val Res.string.navigation_start: StringResource by lazy {
      StringResource("string:navigation_start", "navigation_start", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5221, 36),
      ))
    }

@delegate:ResourceContentHash(594_266_404)
internal val Res.string.no_speed_camera_on_route: StringResource by lazy {
      StringResource("string:no_speed_camera_on_route", "no_speed_camera_on_route", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5258, 72),
      ))
    }

@delegate:ResourceContentHash(-1_240_351_277)
internal val Res.string.options_title: StringResource by lazy {
      StringResource("string:options_title", "options_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5331, 33),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("add_stop", Res.string.add_stop)
  map.put("arrival_label", Res.string.arrival_label)
  map.put("avoid_motorways", Res.string.avoid_motorways)
  map.put("back", Res.string.back)
  map.put("cancel", Res.string.cancel)
  map.put("character_flowing", Res.string.character_flowing)
  map.put("character_pleasant", Res.string.character_pleasant)
  map.put("character_twisty", Res.string.character_twisty)
  map.put("character_very_twisty", Res.string.character_very_twisty)
  map.put("clear_field", Res.string.clear_field)
  map.put("clear_stops", Res.string.clear_stops)
  map.put("clear_stops_message", Res.string.clear_stops_message)
  map.put("clear_stops_title", Res.string.clear_stops_title)
  map.put("close", Res.string.close)
  map.put("collapse", Res.string.collapse)
  map.put("curvature_value", Res.string.curvature_value)
  map.put("decrease", Res.string.decrease)
  map.put("departure_label", Res.string.departure_label)
  map.put("direction_e", Res.string.direction_e)
  map.put("direction_n", Res.string.direction_n)
  map.put("direction_ne", Res.string.direction_ne)
  map.put("direction_nw", Res.string.direction_nw)
  map.put("direction_s", Res.string.direction_s)
  map.put("direction_se", Res.string.direction_se)
  map.put("direction_sw", Res.string.direction_sw)
  map.put("direction_w", Res.string.direction_w)
  map.put("drag_stop", Res.string.drag_stop)
  map.put("engine_label", Res.string.engine_label)
  map.put("engine_not_configured", Res.string.engine_not_configured)
  map.put("error_engine", Res.string.error_engine)
  map.put("error_export", Res.string.error_export)
  map.put("error_favorite", Res.string.error_favorite)
  map.put("error_favorite_not_found", Res.string.error_favorite_not_found)
  map.put("error_gpx_invalid", Res.string.error_gpx_invalid)
  map.put("error_gpx_read", Res.string.error_gpx_read)
  map.put("error_invalid_response", Res.string.error_invalid_response)
  map.put("error_location", Res.string.error_location)
  map.put("error_loop_no_departure", Res.string.error_loop_no_departure)
  map.put("error_network", Res.string.error_network)
  map.put("error_no_loop", Res.string.error_no_loop)
  map.put("error_no_route", Res.string.error_no_route)
  map.put("error_rate_limited", Res.string.error_rate_limited)
  map.put("error_search", Res.string.error_search)
  map.put("error_speed_cameras", Res.string.error_speed_cameras)
  map.put("error_too_many_stops", Res.string.error_too_many_stops)
  map.put("expand", Res.string.expand)
  map.put("export_gpx_short", Res.string.export_gpx_short)
  map.put("favorite_delete", Res.string.favorite_delete)
  map.put("favorite_delete_confirm", Res.string.favorite_delete_confirm)
  map.put("favorite_deleted", Res.string.favorite_deleted)
  map.put("favorite_imported_badge", Res.string.favorite_imported_badge)
  map.put("favorite_name_label", Res.string.favorite_name_label)
  map.put("favorite_options", Res.string.favorite_options)
  map.put("favorite_rename", Res.string.favorite_rename)
  map.put("favorite_save", Res.string.favorite_save)
  map.put("favorite_save_title", Res.string.favorite_save_title)
  map.put("favorite_saved", Res.string.favorite_saved)
  map.put("favorite_saved_label", Res.string.favorite_saved_label)
  map.put("favorites_button", Res.string.favorites_button)
  map.put("favorites_empty", Res.string.favorites_empty)
  map.put("favorites_failed", Res.string.favorites_failed)
  map.put("favorites_import_gpx", Res.string.favorites_import_gpx)
  map.put("favorites_title", Res.string.favorites_title)
  map.put("gpx_choose_track_message", Res.string.gpx_choose_track_message)
  map.put("gpx_choose_track_title", Res.string.gpx_choose_track_title)
  map.put("gpx_points_confirm", Res.string.gpx_points_confirm)
  map.put("gpx_points_message", Res.string.gpx_points_message)
  map.put("gpx_points_title", Res.string.gpx_points_title)
  map.put("gpx_saved_to_favorites", Res.string.gpx_saved_to_favorites)
  map.put("imported_close", Res.string.imported_close)
  map.put("imported_hint", Res.string.imported_hint)
  map.put("imported_title", Res.string.imported_title)
  map.put("increase", Res.string.increase)
  map.put("label_my_position", Res.string.label_my_position)
  map.put("level_high", Res.string.level_high)
  map.put("level_low", Res.string.level_low)
  map.put("level_normal", Res.string.level_normal)
  map.put("locate_me", Res.string.locate_me)
  map.put("locating_rider", Res.string.locating_rider)
  map.put("loop_direction_any", Res.string.loop_direction_any)
  map.put("loop_direction_label", Res.string.loop_direction_label)
  map.put("loop_from", Res.string.loop_from)
  map.put("loop_generate", Res.string.loop_generate)
  map.put("loop_generating", Res.string.loop_generating)
  map.put("loop_hint", Res.string.loop_hint)
  map.put("loop_reroll", Res.string.loop_reroll)
  map.put("loop_target_distance", Res.string.loop_target_distance)
  map.put("loop_target_duration", Res.string.loop_target_duration)
  map.put("map_pick_arrival", Res.string.map_pick_arrival)
  map.put("map_pick_departure", Res.string.map_pick_departure)
  map.put("map_pick_save_place", Res.string.map_pick_save_place)
  map.put("map_pick_stop", Res.string.map_pick_stop)
  map.put("mode_loop", Res.string.mode_loop)
  map.put("move_down", Res.string.move_down)
  map.put("move_up", Res.string.move_up)
  map.put("my_position", Res.string.my_position)
  map.put("navigation_simulate", Res.string.navigation_simulate)
  map.put("navigation_start", Res.string.navigation_start)
  map.put("no_speed_camera_on_route", Res.string.no_speed_camera_on_route)
  map.put("options_title", Res.string.options_title)
}
